export const AnimationData = {
  frames: {
    '09': {
      frame: { x: 0, y: 0, w: 545, h: 674 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 564, y: 83, w: 545, h: 674 },
      sourceSize: { w: 1200, h: 962 },
    },
    11: {
      frame: { x: 545, y: 0, w: 545, h: 674 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 564, y: 83, w: 545, h: 674 },
      sourceSize: { w: 1200, h: 962 },
    },
    10: {
      frame: { x: 1090, y: 0, w: 544, h: 674 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 674 },
      sourceSize: { w: 1200, h: 962 },
    },
    '08': {
      frame: { x: 0, y: 674, w: 544, h: 671 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 671 },
      sourceSize: { w: 1200, h: 962 },
    },
    12: {
      frame: { x: 544, y: 674, w: 544, h: 671 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 671 },
      sourceSize: { w: 1200, h: 962 },
    },
    '07': {
      frame: { x: 1088, y: 674, w: 544, h: 670 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 670 },
      sourceSize: { w: 1200, h: 962 },
    },
    13: {
      frame: { x: 1634, y: 0, w: 544, h: 670 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 670 },
      sourceSize: { w: 1200, h: 962 },
    },
    '00': {
      frame: { x: 1634, y: 670, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '01': {
      frame: { x: 0, y: 1345, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '02': {
      frame: { x: 544, y: 1345, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '03': {
      frame: { x: 1088, y: 1345, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '04': {
      frame: { x: 1632, y: 1345, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '05': {
      frame: { x: 2178, y: 0, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    '06': {
      frame: { x: 2178, y: 668, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    14: {
      frame: { x: 2178, y: 1336, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    15: {
      frame: { x: 0, y: 2013, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    16: {
      frame: { x: 544, y: 2013, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    17: {
      frame: { x: 1088, y: 2013, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    18: {
      frame: { x: 1632, y: 2013, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    19: {
      frame: { x: 2176, y: 2013, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    20: {
      frame: { x: 2722, y: 0, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    21: {
      frame: { x: 2722, y: 668, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    22: {
      frame: { x: 2722, y: 1336, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    23: {
      frame: { x: 2722, y: 2004, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
    24: {
      frame: { x: 3266, y: 0, w: 544, h: 668 },
      rotated: false,
      trimmed: true,
      spriteSourceSize: { x: 565, y: 83, w: 544, h: 668 },
      sourceSize: { w: 1200, h: 962 },
    },
  },
  animations: {
    default: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
    ],
  },
};
